import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, X } from "@phosphor-icons/react";
import { useBeta } from "../context/BetaContext";

// Non-blocking first-expedition coach mark. Renders as a banner ABOVE the content it explains,
// so it never covers decision buttons, timing controls, wallet info, or accessibility controls.
// Only shows for eligible beta players before their first completed expedition.
export default function GuidanceBanner({ id, title, children }) {
  const { guidanceActive, dismissGuidance } = useBeta();
  if (!guidanceActive) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mb-4 flex items-start gap-3 rounded-sm border border-ff-gold/35 bg-ff-gold/10 p-3"
      data-testid={`guidance-${id}`}
      role="note"
    >
      <Lightbulb size={20} weight="duotone" className="mt-0.5 shrink-0 text-ff-gold" />
      <div className="min-w-0 flex-1">
        <div className="text-xs font-semibold uppercase tracking-wide text-ff-gold">{title}</div>
        <p className="mt-0.5 text-sm leading-relaxed text-ff-parchment/90">{children}</p>
      </div>
      <button
        onClick={dismissGuidance}
        data-testid={`guidance-dismiss-${id}`}
        aria-label="Dismiss guidance"
        className="shrink-0 rounded-sm p-1 text-ff-muted transition-colors hover:text-ff-gold"
      >
        <X size={16} />
      </button>
    </motion.div>
  );
}
